import React from 'react';
import { Card, Typography } from 'antd';

const { Title } = Typography;

const NotificationSettings: React.FC = () => {
  return (
    <Card>
      <Title level={4}>Notification Settings</Title>
      <p>Configure email, SMS, and push notification preferences.</p>
      <p>Manage notification templates and delivery settings.</p>
    </Card>
  );
};

export default NotificationSettings; 